<template>
  <div>
    <PageTitle
      title="Purchase Orders"
      :btnCreate="true"
      :createRoute="'/purchase-order/add'"
      :permission="'Purchase Order Create'"
    />
    <v-container fluid class="lighten-12 container">
      <v-card class="lighten-12 card-content">
        <TableFilters
          :filters="[
            'supplier',
            'search',
            'dateRange',
            'warehouse',
            'purchaseOrderStatus',
          ]"
          v-model="filter"
          :columns="columns"
        ></TableFilters>
      </v-card>

      <v-card class="lighten-12 mt-2">
        <v-container fluid class="light gray lighten-12">
          <ValidationObserver ref="observer">
            <form>
              <v-row v-if="messages.length != 0">
                <v-col>
                  <v-card>
                    <v-card-text>
                      <v-row>
                        <template>
                          <v-alert
                            v-for="msg in messages"
                            :key="msg"
                            class="messages"
                            outlined
                            type="error"
                          >
                            {{ msg }}
                          </v-alert>
                        </template>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-card-text class="pa-0">
                  <v-data-table
                    :items-per-page="paginationOptions.perPage"
                    :headers="headers"
                    :items="PurchaseOrderList"
                    hide-default-footer
                  >
                    <template v-slot:no-data>
                      <div class="mt-16 container justify-center item-center">
                        <noData name="Order" />
                      </div>
                    </template>

                    <!-- Reference No -->
                    <template v-slot:item.reference_number="{ item }">
                      <CopyTableCell :text="item.reference_number" />
                    </template>

                    <!-- Date -->
                    <template v-slot:item.date="{ item }">
                      {{ item.date | formatDate }}
                    </template>

                    <!-- Supplier -->
                    <template v-slot:item.supplier="{ item }">
                      {{ item.supplier | hasName }}
                    </template>

                    <!-- Status -->
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :x-small="true"
                        class="ma-2"
                        label
                        text-color="white"
                        :color="getPurchaseOrderStatusColor(item.status)"
                        dark
                      >
                        {{ item.status }}
                      </v-chip>
                    </template>

                    <!-- Active / Archived -->
                    <template v-slot:item.is_active="{ item }">
                      <v-chip
                        :x-small="true"
                        class="ma-2"
                        label
                        text-color="white"
                        :color="getStatusColor(item.is_active)"
                        dark
                      >
                        {{ item.is_active ? "Active" : "Archived" }}
                      </v-chip>
                    </template>

                    <!-- Actions -->
                    <template v-slot:item.actions="{ item }">
                      <list-menu
                        feature="purchase-order"
                        :item="item"
                        viewPermission="Purchase Order Show"
                        editPermission="Purchase Order Edit"
                        @refreshList="refreshData"
                      />
                    </template>

                    <template v-slot:footer="{}">
                      <paginationComponent
                        @paginationOptions="setPaginationOptions"
                        :url="'purchases-orders'"
                        @response="receivePurchaseOrderData"
                        :filter="filter"
                        ref="pagination"
                      />
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-row>
            </form>
          </ValidationObserver>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { has } from "lodash";
import noData from "../../../components/shared/noItem";
import TableFilters from "@/components/base/TableFilters";
import paginationComponent from "../../shared/components/pagination.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    paginationOptions: {},
    purchaseOrderStatus: ["Pending", "Canceled", "Received"],
    messages: [],
    errors: [],
    columns: [
      {
        text: "Date",
        value: "date",
        show: true,
        align: "left",
        disabled: true,
        width: "13.5%",
      },
      {
        text: "Reference no",
        value: "reference_number",
        show: true,
        align: "left",
        disabled: true,
        width: "13.5%",
      },
      {
        text: "Supplier",
        value: "supplier",
        show: true,
        align: "left",
        disabled: false,
        width: "12.5%",
      },
      {
        text: "Warehouse",
        value: "wareHouse.name",
        show: true,
        align: "left",
        disabled: true,
        width: "12.5%",
      },
      {
        text: "Purchase order status",
        value: "status",
        show: true,
        align: "center",
        disabled: false,
        width: "12.5%",
      },
      {
        text: "Actions",
        value: "actions",
        show: true,
        disabled: true,
        align: "center",
        width: "12.5%",
      },
    ],

    PurchaseOrderList: [],
    date_range: [],
    filter: {
      invoice_status: "",
      start: "",
      end: "",
      amount: "",
      supplier: "",
      search: "",
      status: "",
    },
  }),

  components: {
    ValidationProvider,
    ValidationObserver,
    paginationComponent,
    noData,
    TableFilters,
  },

  computed: {
    ...mapGetters(["getInvoiceStatusOptions"]),
    ...mapGetters(["supplier", "GetAllSuppliers"]),

    headers() {
      return this.columns.filter((item) => item.show);
    },
  },

  methods: {
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },

    refreshData() {
      this.$refs.pagination.refreshData();
    },

    receivePurchaseOrderData(data) {
      data.forEach((element) => {
        element.selectedStatus = element.status;
      });
      this.PurchaseOrderList = data;
    },

    getStatusColor(is_active) {
      return is_active ? "green" : "gray";
    },

    getPurchaseOrderStatusColor(status) {
      switch (status) {
        case "Received":
          return "green";
        case "Pending":
          return "orange";
        case "Canceled":
          return "red";
      }
    },
  },

  filters: {
    hasName(value) {
      if (has(value, "name")) return value.name;
      return "-";
    },

    formatDate(value) {
      if (!value) return "-";
      return moment(value).format("DD/MM/YYYY");
    },
  },
};
</script>
